import { Component, EventEmitter, Input, Output, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { Ng2ImgMaxService } from 'ng2-img-max';
import { ProductImage } from '../Models/product'
import { SpinnerService } from '../Services/spinner';
import { ViewChild } from '@angular/core';


@Component({
  selector: 'image-field',
	templateUrl: '../Templates/imagefield.component.html',
  styleUrls: ['../Styles/imagefield.scss']
})


export class ImageFieldComponent {
  @Input() id: string;
  @Input() name: string;
  @Input() label: string;
  @Input() alert_required_text: string;
  @Input() isrequired: boolean = true;
  @Input() model: ProductImage;
  @Input() width: number = 500;
  @Input() height: number = 500;
  @Input() aspectRatio: string = undefined;

  @ViewChild('file')
  @ViewChild('file', {read: ElementRef}) private fileInput: ElementRef;

  @Output()
  imgChange: EventEmitter<string> = new EventEmitter();

  public orgImage: any;
  public croppedImage: any;

  public orgBase64EncodedImage: string;
  public base64EncodedImage: string;

  public imageChangedEvent: any = '';

  constructor(private ng2ImgMax: Ng2ImgMaxService,
              private sanitizer: DomSanitizer,
              private spinner: SpinnerService
             ) {}

  public isvalid(): boolean {

    if (!this.isrequired) {
      return true;
    } else {
      return this.model.value != null && this.model.value != undefined;
    }
  }

  /**
   *  ng-image-cropper related functions
   */

  public imageCropped(image: string) {

    let imageArr = image.split(";");

    // image is a Base64 encoded string of the cropped image
    this.croppedImage = image;

    // Maybe some more defensive programming here?
    this.model.filetype = imageArr[0].split(":")[1];
    this.model.value = imageArr[1].split(',')[1];
  }

  public imageLoaded() {
    // show cropper
  }

  public loadImageFailed() {
    // show message
  }

  /**
   * handle the change event: read the b64 data from the file input
   * and store it in the member variable so the img field in the template
   * can preview the image
   */
  public onFileChange(event) {

    let reader = new FileReader();

    if(event.target.files && event.target.files.length > 0) {
      let image = event.target.files[0];
      if (image) {

        this.spinner.start();

        this.ng2ImgMax.resizeImage(image, this.width, this.height).subscribe(
          result => {
            // result is a Blob.
            reader.readAsDataURL(result);
            reader.onload = () => {
              this.model['filename'] = result.name;
              this.model['filetype'] = result.type;

              this.model['value'] = reader.result.split(',')[1];
              this.orgImage = this.model['value'];

              this.base64EncodedImage = this.model.value;
              this.orgBase64EncodedImage = this.model.value;

              this.imgChange.next(this.name);
            };

            // kickstart image crop editor
            this.imageChangedEvent = event;
            this.spinner.stop();
          },
          error => {
            console.log('Error resizing image');
            this.spinner.stop();
          }
        );
      }
    }
  }

  public remove() {

    // clear the html input widget so the same file can be selected again
    this.fileInput.nativeElement.value = "";

    this.model.filename = "";
    this.model.filetype = "";
    this.model.value = "";

    // Remove crop image editor
    this.imageChangedEvent = event;
  }

  public removeCroppedImage() {

    // revert to initial upload
    this.model.value = this.orgImage;
    this.base64EncodedImage = this.orgBase64EncodedImage;
    this.croppedImage = "";

    // Remove crop image editor
    this.imageChangedEvent = event;
  }

  /**
   * Set image source for create or edit.
   */
  public getSrc(): any {

    if (this.model && this.model.value) {
      if (this.isURL(this.model.value)) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.model.value);
      } else if (this.croppedImage) {
        return this.croppedImage;
      } else {
        return `data:${this.model.filetype};base64,${this.model.value}`;
      }
    } else {
      return "";
    }
  }


  /**
   * Check whether IMG value is a URL. Note: this is not a proper URL
   * regex, but it works for img src.
   */
  private isURL(str): boolean {
    var expr = /(((https?:\/\/)|(www\.))[^\s]+)/g;

    return expr.test(str);
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/imagefield.component.ts